import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles/index';
import {Button} from '@material-ui/core';
import csvtojson from 'csvtojson';

const styles = theme => ({});

class CsvUploadButton extends Component {

    constructor(props) {
        super(props);
        this.handleFileSelect = this.handleFileSelect.bind(this); // 讓 handleFileSelect 中的 this.refs 不會 undefined
    }

    handleFileSelect(e) {
        e.preventDefault();
        this.refs.fileUploader.click();
    }

    getFileText = (file) => {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.readAsText(file);
            reader.onload = function () {
                resolve(reader.result);
            };
            reader.onerror = function (error) {
                reject(error);
            };
        });
    };

    getFileExtension = (file) => {
        let file_name = file.name;
        let file_name_array = file_name.split('.');
        return file_name_array[file_name_array.length - 1];
    };

    getJsonData = async (fileText) => {
        return await csvtojson().fromString(fileText);
    };

    handleFileChange = async (controller) => {
        try {
            const file = this.refs.fileUploader.files[0];
            const fileExtension = this.getFileExtension(file);
            if (fileExtension !== 'csv') throw new Error('only accept csv file');
            const fileText = await this.getFileText(file);
            const jsonData = await this.getJsonData(fileText);
            if (this.props.onClick) await this.props.onClick(jsonData);
        } catch (e) {
            console.error(e);
            return null;
        }
    };

    render() {

        return (
            <span>
                <input type="file" id="fileUploader" ref="fileUploader" accept=".csv"
                       onChange={this.handleFileChange} style={{display: "none"}}/>
                <Button id={this.props.id}
                        name={this.props.name}
                        className={this.props.className}
                        variant={this.props.variant}
                        color={this.props.color}
                        value={this.props.value}
                        onClick={this.handleFileSelect}>
                    {this.props.label}
                </Button>
            </span>
        );
    }
}

export default withStyles(styles, {withTheme: true})(CsvUploadButton);



// WEBPACK FOOTER //
// ./src/components/UploadButton.js